<template>
  <div class="cart-view">
    <div class="grid-row">
      <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
        <CartStepper />
      </div>
    </div>
    <div class="grid-row">
      <div class="c-12">
        <h1>{{$_('select_your_payment_method')}}</h1>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-9 c-xs-12 c-sm-12 c-md-12 c-lg-9">
        <PaymentCB @mode="payment_mode = $event.mode" :type="'bankcard'"/>
      </div>
      <div class="c-3 c-xs-12 c-sm-12 c-md-12 c-lg-3">
        <CartSummary :step="'payment'" :next_step="''"  :payment="payment_mode" />
      </div>
    </div>
  </div>
</template>

<script>

import CartStepper from '@/modules/panier/components/CartStepper';
import CartSummary from '@/modules/panier/components/CartSummary';
import PaymentCB from '@/modules/panier/components/PaymentCB';

export default {
  name: 'Payment',
  components: {
    CartStepper,
    CartSummary,
    PaymentCB
  },
  data() {
    return {
      payment_mode: ''
    }
  },
  mounted() {
    
  }
}
</script>

<style scoped>
.cart-view {
  padding: 15px;
}
</style>